import { Field } from '../PreviewFields';
import { PreviewHeader } from '../PreviewHeader';

export interface MsmeFormValues {
  UdyamRegistrationNumber: string;
}

export interface MsmeScreenProps {
  /** Live form values — pass from the session runtime; omit in the builder mock. */
  values?: MsmeFormValues;
  onChange?: (patch: Partial<MsmeFormValues>) => void;
  errors?: Partial<Record<keyof MsmeFormValues, string>>;
  /** Method display name ("MSME Verification (Udyam)") — shown for consistency. */
  method?: string;
}

// MSME Verification (Udyam) — the applicant enters their Udyam Registration Number;
// the provider returns the enterprise's full profile / financial / employment /
// banking / address / industry details. Single method (Udyam without OTP, Protean).
// OWN interim design — swap for the designer's screen when it arrives.
export function MsmeScreen({ values, onChange, errors }: MsmeScreenProps) {
  return (
    <>
      <PreviewHeader
        title="MSME Verification (Udyam)"
        subtitle="Enter your Udyam registration details"
      />
      <Field
        label="Udyam Registration Number"
        placeholder="UDYAM-XX-00-0000000"
        hint="Your Udyam registration number (format: UDYAM-MP-23-0007772)"
        value={values?.UdyamRegistrationNumber}
        onChange={onChange ? (v) => onChange({ UdyamRegistrationNumber: v }) : undefined}
        error={errors?.UdyamRegistrationNumber}
      />
      <p className="mt-2 text-[14px] leading-tight text-[#666666]">
        We look up your enterprise's Udyam registration and verify its profile, classification, and
        financial details. We do not store data beyond what is required by law.
      </p>
    </>
  );
}
